import React, { useState, useEffect } from "react";
import "@fontsource/oswald";
import api from "../../utils/axiosInstance";
import HeaderBlue from "../../components/HeaderBlue";
import FooterBlue from "../../components/FooterBlue";

const RegisteredCarriers = () => {
    const [carriers, setCarriers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCarriers = async () => {
            try {
                const res = await api.get("/carriers");
                setCarriers(res.data);
            } catch (error) {
                console.error("Failed to fetch carriers:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchCarriers();
    }, []);

    return (
        <>
            <HeaderBlue />

            {/* Hero Section */}
            <section className="w-full py-60 relative bg-cover bg-top px-3"
                style={{
                    backgroundImage: "url('./assets/registeredemployers.jpg')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                }}>
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-white/10 z-0"></div>
                <div className="md:px-40 relative z-10">
                    <h2 className="text-white text-6xl font-oswald drop-shadow-lg">REGISTERED CARRIERS</h2>
                    <p className="text-white text-xl font-semibold font-oswald mt-2">
                        Meet some of the top carriers in the trucking industry <br className="hidden md:block" />
                        who are actively hiring and supporting drivers nationwide.
                    </p>
                </div>
            </section>

            {/* Main Content */}
            <main className="container max-w-6xl mx-auto px-4 md:px-6 mt-8 md:mt-16">
                <div className="text-center mb-10">
                    <h2 className="bluetext1 text-4xl md:text-5xl mb-4 tracking-wider">
                        Registered Carriers
                    </h2>
                    <p className="text-gray max-w-2xl mx-auto text-lg">
                        Explore our network of trusted carriers offering excellent opportunities for drivers
                    </p>
                </div>

                {loading ? (
                    <div className="text-center text-gray-600">Loading carriers...</div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">
                        {carriers.map((carrier, idx) => (
                            <div
                                key={carrier._id || carrier.name || idx}
                                className="bg-white rounded-xl shadow-lg border border-border p-8 flex flex-col items-start transition-all duration-300 hover:shadow-xl employer-card"
                            >
                                <img
                                    src={
                                        carrier.companyLogo
                                            ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${carrier.companyLogo}`
                                            : carrier.logo
                                                ? carrier.logo
                                                : "https://via.placeholder.com/60"
                                    }
                                    alt={`${carrier.companyName || carrier.name} Logo`}
                                    className="w-16 h-16 object-contain rounded-lg bg-light-gray mb-5"
                                    onError={(e) => {
                                        e.target.src = "https://via.placeholder.com/60";
                                    }}
                                />

                                <div className="bluetext1 text-xl font-bold mb-2">
                                    {carrier.companyName || carrier.name}
                                </div>
                                <div className="text-gray flex items-center gap-1 mb-4">
                                    <i className="fas fa-map-marker-alt"></i>{" "}
                                    {carrier.city && carrier.state
                                        ? `${carrier.city}, ${carrier.state}`
                                        : carrier.location}
                                </div>
                                <p className="mb-5">{carrier.companyDesc || carrier.description}</p>
                                <div className="flex flex-wrap gap-2 mb-4">
                                    {(carrier.tags || []).map((tag) => (
                                        <span
                                            key={tag}
                                            className="blueBg1 text-white text-sm rounded px-3 py-1 font-medium"
                                        >
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </main>
            <FooterBlue />
        </>
    );
};

export default RegisteredCarriers;
